import { aiDataConsentMessages } from '../i18n/aiDataConsent'
import { aiPrivacyProtection } from '../i18n/aiPrivacy'

export const LEGAL_VERSION = '2026-11-03.1'
export const SUPPORT_EMAIL = 'admin@sponelabs.com'
export const SUPPORT_URL = 'https://voxnela.web.app/#/contact'
export const TERMS_URL = 'https://voxnela.web.app/#/terms'
export const PRIVACY_URL = 'https://voxnela.web.app/#/privacy'

const supportBody = [
  'Merhaba Voxnela Destek Ekibi,',
  '',
  'Destek konusu:',
  '',
  'Kullandığım platform (Web / iOS / Mac):',
  'Cihaz ve işletim sistemi:',
  'Proje kimliği (varsa):',
  '',
  'Sorunun veya talebin açıklaması:',
  '',
  'Teşekkürler.',
].join('\n')

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('Voxnela destek talebi')}&body=${encodeURIComponent(supportBody)}`

export interface LegalSection {
  id: string
  title: string
  paragraphs: string[]
  bullets?: string[]
  note?: string
}

export interface LegalReference {
  label: string
  href: string
}

export interface LegalDocument {
  eyebrow: string
  title: string
  lead: string
  version: string
  effectiveDate: string
  lastUpdated: string
  sections: LegalSection[]
  references: LegalReference[]
}

export const termsDocument: LegalDocument = {
  eyebrow: 'Voxnela hizmet koşulları',
  title: 'Kullanım koşulları',
  lead: 'Bu koşullar, Voxnela web ve iOS uygulamasında yapay zekâ ile görsel oluşturma ve düzenleme hizmetinin kullanımını düzenler.',
  version: LEGAL_VERSION,
  effectiveDate: '3 Kasım 2026',
  lastUpdated: '3 Kasım 2026',
  sections: [
    {
      id: 'kapsam',
      title: '1. Kapsam ve hesap',
      paragraphs: [
        `Voxnela, Sponelabs tarafından sunulur. Hesap açarak veya hizmeti kullanarak bu koşulları kabul edersiniz. Sorularınızı ${SUPPORT_EMAIL} adresine gönderebilirsiniz.`,
        'Voxnela’yı hesap oluşturmadan kullanabilir, görsel üretebilir ve abonelik satın alabilirsiniz; bu içerikler cihazınızdaki anonim bir kullanıcı kimliğine bağlanır. Görsellerinize ve aboneliğinize diğer cihazlarınızdan da erişmek isterseniz isteğe bağlı olarak oturum açabilirsiniz. Hesap erişiminizi korumak ve yetkisiz kullanımı bildirmek sizin sorumluluğunuzdadır.',
      ],
    },
    {
      id: 'hizmet',
      title: '2. Görsel üretimi ve düzenleme',
      paragraphs: [
        'Uygulama, yazdığınız istemleri ve sağladığınız desteklenen görselleri kullanarak yeni görseller oluşturur veya mevcut görselleri düzenler. Yapay zekâ sonuçları her zaman beklentinize uymayabilir; yayımlamadan önce çıktıları incelemelisiniz.',
        'Tamamlanan görseller hesabınıza bağlı proje kayıtları olarak saklanır. Galerinizde yalnız hesabınıza ait projeler gösterilir.',
      ],
    },
    {
      id: 'materyaller',
      title: '3. Yüklediğiniz materyaller',
      paragraphs: [
        'Yüklediğiniz görseller, belgeler, metinler ve diğer materyaller üzerindeki haklar sizde veya ilgili hak sahibinde kalır. Hizmeti sunabilmemiz için bu materyalleri saklama, işleme ve talep ettiğiniz görseli oluşturmak üzere yapay zekâ sağlayıcılarına iletme izni verirsiniz.',
        'Başka kişilerin görüntülerini veya üçüncü tarafların korunan materyallerini kullanırken gerekli izinlere sahip olmalısınız. Materyallerinizi başka kullanıcıların galerisine eklemeyiz.',
      ],
    },
    {
      id: 'haklar',
      title: '4. Görsel hakları ve üyelik',
      paragraphs: [
        'Planınızda gösterilen görsel hakları sunucudaki hesabınıza kaydedilir. Başarıyla tamamlanan her yeni görsel veya düzenleme bir hak kullanır; başarısız işlem için hak düşülmez. Aynı görseli tekrar görüntülemek veya indirmek yeni hak kullanmaz.',
        'Ücretli planların fiyatı, dönemi ve yenilenme koşulları satın alma ekranında gösterilir. Hakların yenilenmesi ve kullanılabilir bakiye, hesabınızın üyelik bilgilerine göre belirlenir. Uygulamayı silmek aboneliği kendiliğinden iptal etmez.',
      ],
    },
    {
      id: 'kullanim',
      title: '5. Kabul edilebilir kullanım',
      paragraphs: [
        'Hizmeti hukuka aykırı, aldatıcı, istismar edici veya başkalarının haklarını ihlal eden görseller oluşturmak için kullanamazsınız. Güvenlik önlemlerini aşmaya veya hizmeti kötüye kullanmaya yönelik işlemler kısıtlanabilir.',
      ],
    },
    {
      id: 'saklama',
      title: '6. Saklama ve hesap işlemleri',
      paragraphs: [
        'Görsellerinizi galeri üzerinden indirebilir veya paylaşabilirsiniz. Hesap ve veri silme seçenekleri uygulamadaki hesap ayarlarında sunulur. Yasal yükümlülükler nedeniyle tutulması gereken sınırlı işlem kayıtları ayrı saklanabilir.',
        'Hizmetin kesintisiz veya her görselin kusursuz olacağını garanti etmeyiz. Kanunen vazgeçilemeyen tüketici haklarınız saklıdır.',
      ],
    },
    {
      id: 'iletisim',
      title: '7. Değişiklikler ve iletişim',
      paragraphs: [
        `Önemli değişiklikler uygun bir kanalla duyurulur. Bu koşullarla ilgili sorularınızı ${SUPPORT_EMAIL} adresine gönderebilirsiniz.`,
      ],
    },
  ],
  references: [],
}

export const privacyDocument: LegalDocument = {
  eyebrow: 'Voxnela veri kullanımı',
  title: 'Gizlilik politikası',
  lead: 'Bu politika, Voxnela görsel üretim hizmetinde hesap, görsel, proje, üyelik ve teknik verilerin nasıl işlendiğini açıklar.',
  version: '2026-11-03.1-face-data',
  effectiveDate: '3 Kasım 2026',
  lastUpdated: '3 Kasım 2026',
  sections: [
    {
      id: 'sorumlu',
      title: '1. Veri sorumlusu ve iletişim',
      paragraphs: [
        `Voxnela markası altında hizmet veren Sponelabs, hizmetin amaç ve araçlarını belirlediği işlemlerde veri sorumlusu olarak hareket eder. Gizlilik taleplerinizi ${SUPPORT_EMAIL} adresine iletebilirsiniz.`,
      ],
    },
    {
      id: 'veriler',
      title: '2. İşlenen veriler',
      paragraphs: [
        'Hesap kimliğiniz, e-posta adresiniz ve profil bilgileriniz; yazdığınız istemler, yüklediğiniz materyaller, üretilen görseller ve proje sürümleri; üyelik ve görsel hakkı bakiyeniz; işlem, güvenlik ve hata kayıtları işlenebilir.',
        'Tam ödeme kartı bilgilerinizi Voxnela saklamaz. Satın alma işlemleri ilgili mağaza veya ödeme sağlayıcısı tarafından yürütülür.',
        'Voxnela’yı hesap oluşturmadan kullanabilirsiniz. Bu durumda görselleriniz, görsel haklarınız ve satın aldığınız abonelik cihazınızda oluşturulan anonim bir kullanıcı kimliğine bağlanır. Ücretsiz hakların her cihazda yalnız bir kez kullanılabilmesi için cihazın üretici kimliğinin tek yönlü özeti (hash) yalnız bu amaçla, silme talebinden sonra da saklanır. Sonradan giriş yaparsanız bu içerikler hesabınıza taşınır.',
      ],
    },
    {
      id: 'amaclar',
      title: '3. Kullanım amaçları',
      paragraphs: [
        'Verileri oturum açmanızı sağlamak, görsel oluşturmak ve düzenlemek, projeleri hesabınızla ilişkilendirip cihazlar arasında eşitlemek, hak bakiyesini yönetmek, satın almaları doğrulamak, güvenliği sağlamak ve destek taleplerini yanıtlamak için kullanırız.',
      ],
    },
    {
      id: 'saglayicilar',
      title: '4. Hizmet sağlayıcıları',
      paragraphs: [
        aiDataConsentMessages.tr.openai,
        aiDataConsentMessages.tr.anthropic,
        aiDataConsentMessages.tr.storage,
        aiDataConsentMessages.tr.choice,
        aiPrivacyProtection.tr,
      ],
    },
    {
      id: 'yuz-verileri',
      title: '5. Yüz verileri',
      paragraphs: [
        'Voxnela yüz geometrisi, yüz şablonu veya biyometrik tanımlayıcı oluşturmaz ya da saklamaz; yüz verilerini kimlik doğrulama, kişileri tanıma, takip, reklam veya profil oluşturma için kullanmaz. Kapsamdaki tek yüz verisi, görsel oluşturmak veya düzenlemek için kendi seçtiğiniz ve yüz içerebilen fotoğraflardır.',
        'Bu fotoğraflar yalnız istediğiniz görseli oluşturmak için şifreli bağlantıyla OpenAI API’ye gönderilir; zaman çizelgesi görsellerinde tarih ve metin okumak için Anthropic’e de gönderilebilir. Bu sağlayıcılar yayımladıkları API veri politikalarına göre verileri model eğitiminde kullanmaz ve kötüye kullanım denetimi için en fazla 30 gün sakladıktan sonra siler. Fotoğraflar başka hiçbir üçüncü tarafla paylaşılmaz ve satılmaz.',
        'İsteğe bağlı rötuş araçları, yüz hatlarının konumunu (yüz noktaları) tahmin etmek için Google MediaPipe modelini tamamen cihazınızda çalıştırır. Bu noktalar yalnız rötuş maskesi için bellekte kullanılır; sunucuya gönderilmez, saklanmaz ve düzenleyici kapandığında silinir.',
        'Fotoğraflarınız ve üretilen görseller Google Firebase / Google Cloud Storage’da, yalnız hesabınızın veya anonim kullanıcı kimliğinizin erişebildiği özel klasörlerde şifreli olarak saklanır. Bir görseli sildiğinizde sürümleri ve kaynak fotoğrafları hemen silinir. Ayarlar > Profil bölümünden veri silme (30 gün) veya hesap silme (15 gün) talep ettiğinizde, süre sonunda tüm fotoğraf ve görselleriniz kalıcı olarak silinir.',
      ],
    },
    {
      id: 'erisim',
      title: '6. Görsellere erişim',
      paragraphs: [
        'Galeri kayıtları hesabınızın kullanıcı kimliğiyle ilişkilendirilir; oturum açmamış kullanıcıya kişisel galeri listesi sunulmaz. İndirme ve paylaşım bağlantılarını başkalarıyla paylaştığınızda bağlantıya erişen kişiler ilgili dosyayı görebilir.',
      ],
    },
    {
      id: 'saklama-silme',
      title: '7. Saklama ve silme',
      paragraphs: [
        'Proje ve hesap verileri hizmetin sağlanması ve yasal yükümlülüklerin yerine getirilmesi için gerekli süre boyunca saklanır. Uygulamadaki hesap ayarlarından veri veya hesap silme talebi oluşturabilirsiniz. Zorunlu yasal kayıtlar ilgili süre boyunca tutulabilir.',
      ],
    },
    {
      id: 'haklar',
      title: '8. Haklarınız',
      paragraphs: [
        `Kişisel verilerinize ilişkin erişim, düzeltme, silme ve diğer yasal talepleriniz için ${SUPPORT_EMAIL} adresinden bize ulaşabilirsiniz. Hesap sahipliğini doğrulamak için gerekli ölçüde ek bilgi isteyebiliriz.`,
      ],
    },
  ],
  references: [
    { label: 'OpenAI Data Processing Addendum', href: 'https://openai.com/policies/data-processing-addendum/' },
    { label: 'Google Cloud Data Processing Addendum', href: 'https://cloud.google.com/terms/data-processing-addendum' },
    { label: 'OpenAI API data controls', href: 'https://developers.openai.com/api/docs/guides/your-data' },
    { label: 'Anthropic Data Processing Addendum', href: 'https://www.anthropic.com/legal/data-processing-addendum' },
  ],
}
